import {getAPIbaseURL} from "@/api/config/init";

const prex = `${getAPIbaseURL()}/relatorio/contribuinte/`;

export function setRelSolicitacaoCadastro(tps_hash) {
    return `${prex}solicitacao_cadastro/${tps_hash}`;
}

export function RelFichaCadastro(aut_hash, eco_codigo) {
    return `${prex}cadastro/${aut_hash}/${eco_codigo}`;
}
